import React from 'react';
import Router, { Link } from 'react-router';
import autobind from 'autobind-decorator';
import Base from 'client/components/base';
import ButtonHeader from 'client/components/header/button-header';
import ButtonRounded from 'client/components/common/button-rounded';
import StringStore from 'client/stores/strings';
import Search from 'client/components/common/search';
import DelayedInput from 'client/components/common/delayed-input';

export default class Header extends Base {
  constructor(props) {
    super(props);

    this.state = {
      query: '',
      isShowingSearchResults: false,
      isSearching: false,
      key: 0,
    };
  }

  @autobind
  onUpdate(e) {
    this.setState({
      query: e.value,
    });
  }

  @autobind
  onSyncUpdate(e) {
    if (e.value === '') {
      // Setting query to empty string will stop the searching immediately
      // so the user gets the fastest response possible.
      this.setState({
        query: '',
        isSearching: false,
      });
    } else {
      this.setState({
        isSearching: true,
      });
    }
  }

  @autobind
  onLeave() {
    this.setState({
      query: '',
      isShowingSearchResults: false,
      key: ++this.state.key, // This forces the input field to rebuild and reapply the defaultValue.
    });
  }

  @autobind
  onFocus() {
    this.setState({
      isShowingSearchResults: true,
    });
  }

  @autobind
  onBlur() {
    this.setState({
      isShowingSearchResults: false,
    });
  }

  @autobind
  onSearchEnd() {
    this.setState({
      isSearching: false,
    });
  }

  render() {
    return (
      <div
        className={
          this.css() +
          (this.state.isShowingSearchResults ? ' showing-result' : '')
        }
      >
        <div className="wrapper">
          <div className="logo">
            <Link to="/" />
          </div>
          <div className="content">
            <div className="tabs">
              <ButtonHeader id="discover" />
              <ButtonHeader id="plus" />
              <ButtonHeader id="about" addClassName="hide-on-small" />
              <ButtonHeader id="podcasters" />
              <ButtonHeader id="advertisers" />
              <ButtonHeader
                id="news"
                addClassName="hide-on-small"
                url="https://blog.acast.com/"
              />
            </div>
          </div>
          <div
            className={
              'search-field' + (this.state.isSearching ? ' searching' : '')
            }
          >
            <div className="inner">
              <DelayedInput
                ref="search"
                onSyncUpdate={this.onSyncUpdate}
                onUpdate={this.onUpdate}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                type="text"
                key={this.state.key}
                defaultValue={this.state.query}
                placeholder={StringStore.get('common.searchPlaceholder')}
              />
              <div className="loader" />
            </div>
          </div>
        </div>
        <div className="search-result">
          <Search onSearchEnd={this.onSearchEnd} query={this.state.query} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/components/header/header.es6